import { useProfile } from "../../../hooks/useProfile";
import noAvatarImage from "../../imagenes/no_avatar.svg";
import "./Avatar.scss";

function Avatar() {
	const { profile } = useProfile();

	if (profile?.url) {
		return (
			<img src={profile.thumbnail || profile.url} className="avatar-icon" />
		);
	}

	return <img src={noAvatarImage} className="avatar-icon" />;
}

export default Avatar;
